import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { FadeUp, MaskLines, Overline } from "./Reveal";

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section ref={ref} id="salone" data-testid="manifesto-section" className="relative py-28 sm:py-40">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14 items-end">
        <div className="lg:col-span-7">
          <Overline>Il salone</Overline>
          <h2 className="mt-8 font-display text-4xl sm:text-6xl lg:text-7xl leading-[1] tracking-tight text-ivory">
            <MaskLines lines={["Non un semplice", <span key="b">taglio. <em className="text-gold-grad">Un rituale</em></span>, "che ti somiglia."]} />
          </h2>
          <FadeUp delay={0.2} className="mt-10 grid sm:grid-cols-2 gap-8 max-w-2xl">
            <p className="text-sm sm:text-base text-ivory/75 leading-relaxed">
              Da Hair Boutique ogni appuntamento inizia ascoltando: cosa desideri, come porti i capelli ogni giorno, che effetto vuoi vedere allo specchio.
            </p>
            <p className="text-sm sm:text-base text-ivory/75 leading-relaxed">
              Lavoriamo solo con aziende partner di cui ci fidiamo: Olaplex, Lisap, ghd e Johnny Verax Professional, per risultati che restano belli anche a casa.
            </p>
          </FadeUp>
        </div>
        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[3/4] overflow-hidden frame-clip">
            <motion.img style={{ y }} src="/img/ig-salone.jpg" alt="Cliente nel salone Hair Boutique" className="absolute inset-0 w-full h-[116%] -top-[8%] object-cover" />
            <div className="absolute inset-0 ring-1 ring-inset ring-gold/30" />
          </div>
          <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.25em] text-ivory/60">@hairboutique_beauty</p>
        </div>
      </div>
    </section>
  );
};
